// src/pages/TermsPage.js
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section className="max-w-4xl mx-auto my-8">
    <h2 className="text-xl font-semibold mb-3">{title}</h2>
    <div className="prose prose-invert max-w-none text-sm leading-6">
      {children}
    </div>
  </section>
);

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <main className="min-h-[calc(100vh-64px)] px-6 py-8">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 inline-flex items-center rounded-md border border-gray-700 px-3 py-1.5 text-sm hover:bg-gray-800"
        >
          ← Back
        </button>

        <h1 className="text-3xl font-bold">Terms & Conditions</h1>
        <p className="mt-2 text-sm text-gray-400">Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <Section title="1. Acceptance of Terms">
        <p>
          By accessing or using Clairifi, you agree to be bound by these Terms & Conditions. If you do
          not agree, do not use the service.
        </p>
      </Section>

      <Section title="2. Use of the Service">
        <ul className="list-disc pl-6">
          <li>You are responsible for your account and for maintaining the confidentiality of your credentials.</li>
          <li>You agree not to misuse the service, interfere with its operation, or attempt unauthorized access.</li>
          <li>You retain ownership of your uploaded data; you grant us a limited license to process it to provide the service.</li>
        </ul>
      </Section>

      <Section title="3. Subscriptions & Billing">
        <p>
          Paid plans, free trials, and usage limits are described in-app. Fees are non-refundable except as
          required by law. We may change pricing with notice. Access may be limited or suspended if payment
          fails or usage exceeds plan limits.
        </p>
      </Section>

      <Section title="4. Data & Privacy">
        <p>
          We process your data to operate, secure, and improve Clairifi. See our{' '}
          <Link to="/privacy" className="underline">Privacy Policy</Link> for details.
        </p>
      </Section>

      <Section title="5. Disclaimers">
        <p>
          Clairifi provides analyses and forecasts for informational purposes only and does not constitute
          financial, legal, or tax advice. Use at your own risk.
        </p>
      </Section>

      <Section title="6. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, Clairifi is not liable for indirect, incidental, special,
          consequential, or punitive damages, or any loss of profits, data, or goodwill.
        </p>
      </Section>

      <Section title="7. Termination">
        <p>
          We may suspend or terminate access for any violation of these Terms or to protect users and the service.
        </p>
      </Section>

      <Section title="8. Changes to Terms">
        <p>
          We may update these Terms from time to time. Continued use after changes take effect constitutes acceptance.
        </p>
      </Section>

      <Section title="Contact">
        <p>Questions? Email <a className="underline" href="mailto:contact@getclairifi.com">contact@getclairifi.com</a>.</p>
      </Section>
    </main>
  );
}
